var React = require('react');

function PlayIconInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"a","d":"M0 0h16.85v26.28H0z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("mask",{"id":"b","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#a"})),React.createElement("path",{"fill":"#FFF","d":"M14.88 15.756l-6.217-.572-.011-7.263c0-.51-.422-1.44-1.446-1.44-.795 0-1.446.643-1.446 1.44v12.232l-1.2-1.718a1.42 1.42 0 0 0-2.328 1.628l3.109 5.774c.27.389.714.444 1.188.444h6.962c1.373 0 2.555-.79 2.824-2.136l.478-5.181c.285-1.426-.535-2.749-1.913-3.208M1.44 10.8A1.44 1.44 0 0 1 0 9.36v-1.8c0-10.08 14.4-10.08 14.4 0v1.8a1.44 1.44 0 0 1-2.88 0v-1.8c0-5.76-8.64-5.76-8.64 0v1.8a1.44 1.44 0 0 1-1.44 1.44","mask":"url(#b)","key":1})])]);
}

PlayIconInline.defaultProps = {"width":"17","height":"27","viewBox":"0 0 17 27"};

module.exports = PlayIconInline;

PlayIconInline.default = PlayIconInline;
